
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton } from '@/components';
import useShop from '@/modules/shop/model/list';
import { ROUTE_NAME_SHOP } from '@/modules/shop/router';
import { Options } from '@/modules/shop/model/mixins';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_SHOP.INDEX,
    components: { AppTable, AppButton, AppCard },
    setup() {
        const { list, total, fetchList, actions } = useShop();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: Options.ShopItemType },
                { type: TableColumnType.Boolean, label: 'Is Published', key: 'isPublished' },
                { type: TableColumnType.Boolean, label: 'Is Best Seller', key: 'isBestseller' },
                { type: TableColumnType.Text, label: 'Price', key: 'price' },
                { type: TableColumnType.Text, label: 'Credit', key: 'credit' },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: { name: ROUTE_NAME_SHOP.TRANSLATE, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_SHOP.EDIT, params: { id: row.id } }
                    }),
                    canShow: (row: any) => row.canEdit,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-copy',
                        theme: 'info',
                        tooltip: 'Clone',
                        to: { name: ROUTE_NAME_SHOP.CLONE, params: { id: row.id } }
                    }),
                    canShow: (row: any) => row.canClone,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, ROUTE_NAME_SHOP };
    }
});
